module.exports = __webpack_public_path__ + "img/icon10.c990bcb8.png";